import React, {useEffect, useState} from 'react';
import {Switch, Route} from 'react-router-dom';
// import {hot} from 'react-hot-loader/root';
import {IntlProvider} from 'react-intl';
import Homepage from '@Pages/Homepage';
import Search from '@Pages/Search';
import NotFound from '@Pages/NotFound';
import SalaryDetails from '@Pages/SalaryDetails';
import SalaryLocationDetails from '@Pages/SalaryLocationDetails';
import Logger from '@ffw/logger-lib';
import {Navigation, initEventsRel} from '@rel/experience';

const routeComponents = [];
const routes = require(`../config/client.routes.json`);
let Component = null;

// Iterate through all supported languages.
for (const lang in routes) {
  if (routes.hasOwnProperty(lang)) {
    // Iterate through all supported routes and components.
    // eslint-disable-next-line
    for (const routeName in routes[lang]) {
      if (routes[lang].hasOwnProperty(routeName)) {
        const route = routes[lang][routeName];
        switch (route.component) {
          case 'homepage':
            Component = Homepage;
            break;
          case 'search':
            Component = Search;
            break;
          case 'salary-details':
            Component = SalaryDetails;
            break;
          case 'salary-location-details':
            Component = SalaryLocationDetails;
            break;
        }
        // Add the route in the renderable array.
        routeComponents.push(<Route exact key={`${lang}-${routeName}`} path={`${route.url}`} component={Component}/>);
      }
    }
  }
}
// Everything that is not defined as route will lead to NotFound page.
routeComponents.push(<Route key='not-found' component={NotFound}/>);

const App = ({currentLanguage, messages, links, isEnableRelNavigation}) => {
  const navigationProps = {
    myRandstad: {
      text: 'my randstad',
      href: '/my-randstad/',
      user: null,
    },
    logo: {
      title: messages?.['MegaMenu.Logo.Title'],
      href: '/',
    },
    aria: {
      navigation: {
        menu: messages?.['MegaMenu.Aria.Navigation.Menu'],
        navigation: messages?.['MegaMenu.Aria.Navigation.Navigation'],
        close: messages?.['MegaMenu.Aria.Navigation.Close'],
      },
      megaMenu: {
        main: messages?.['MegaMenu.Aria.MegaMenu.Main'],
        close: messages?.['MegaMenu.Aria.MegaMenu.Close'],
      },
    },
  };

  const [myRandstadProps, setMyRandstadProps] = useState(navigationProps.myRandstad);

  // Get the language.
  const lang = currentLanguage ? currentLanguage : process.env.REACT_APP_DEFAULT_LANGUAGE;

  if (!messages && typeof window !== 'undefined' && window.__MESSAGES_DATA__) {
    messages = window.__MESSAGES_DATA__;
  }

  useEffect(() => {
    const htmlElement = document.querySelector('html');
    htmlElement.classList.add('js');
    htmlElement.classList.add('js-app-loaded');
  }, []);

  useEffect(() => {
    setMyRandstadProps({
      text: window.myRandstadText ?? myRandstadProps.text,
      href: window.myRandstadUrl ?? myRandstadProps.href,
      user: window.myRandstadUsername ? {
        initials: window.myRandstadUsername?.charAt(0)?.toUpperCase(),
        names: window.myRandstadUsername,
      } : null,
    });
  }, []);

  /**
   * Implement datalayer events from REL for the Mega menu.
   */
  useEffect(() => {
    if (isEnableRelNavigation) {
      initEventsRel();
    }
  }, []);

  const onIntlError = (e) => {
    if (e.includes('in Intl.NumberFormat. Using default locale: ')) {
      return;
    }
    Logger.error(e, 'App.js');
  };

  return (
    <IntlProvider defaultLocale={process.env.REACT_APP_DEFAULT_LANGUAGE} locale={lang} messages={messages} onError={onIntlError}>
      {isEnableRelNavigation && (
        <Navigation
          {...navigationProps}
          myRandstad={myRandstadProps}
          {...links}
        />
      )}
      <Switch>
        {routeComponents}
      </Switch>
    </IntlProvider>
  );
};

export default App;
